import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import confetti from "canvas-confetti";
import { SEGMENT_LABELS, NEEDS_USDOT, NEEDS_FLEET_SIZE, NEEDS_OPERATING_AREA } from "@/components/preregister/preRegisterConstants";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Handles the pre-register form submission: builds the payload, persists the
// referral code locally, and fires the milestone toast/confetti on round signups.
export const usePreRegisterSubmit = ({ segment, form, referredBy, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/leads`, {
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        location: [form.city, form.state].filter(Boolean).join(", ") || null,
        role: SEGMENT_LABELS[segment],
        company: form.company || null,
        segment,
        state: form.state || null,
        usdot_number: NEEDS_USDOT.includes(segment) ? form.usdot || null : null,
        fleet_size: NEEDS_FLEET_SIZE.includes(segment) && form.fleetSize ? Number(form.fleetSize) : null,
        operating_area: NEEDS_OPERATING_AREA.includes(segment) ? form.operatingArea || null : null,
        referred_by: referredBy || null,
        age_confirmed: form.ageConfirmed,
      });
      onSuccess(data.referral_code || null);
      if (data.referral_code && !localStorage.getItem("rr_referral_code")) {
        localStorage.setItem("rr_referral_code", data.referral_code);
        localStorage.setItem("rr_referral_count_seen", "0");
      }
      if (data.signup_position && data.signup_position % 10 === 0) {
        toast.success(`🎉 You're founding driver #${data.signup_position}! Thanks for helping build the RelayRigs network.`, { duration: 6000 });
        confetti({ particleCount: 140, spread: 90, origin: { y: 0.6 }, colors: ["#F2761E", "#0E2A47", "#FFFFFF"] });
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return { submitting, handleSubmit };
};
